import { API_BASE_URL } from "../config/apiBase";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const parseJson = async (res) => {
  const data = await res.json();
  if (!res.ok || data.success === false) {
    throw new Error(data.message || data.error || "Request failed");
  }
  return data;
};

export const startConnectOnboarding = async (sellerId) => {
  const res = await fetch(
    `${API_BASE_URL}/payapi/admin/seller/${sellerId}/connect-onboarding`,
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({}),
    }
  );
  return parseJson(res);
};

export const openConnectPortal = async (sellerId) => {
  const res = await fetch(
    `${API_BASE_URL}/payapi/admin/seller/${sellerId}/connect-portal`,
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({}),
    }
  );
  return parseJson(res);
};

export const fetchConnectSummary = async (sellerId) => {
  const res = await fetch(
    `${API_BASE_URL}/payapi/admin/seller/${sellerId}/connect-summary`,
    {
      headers: authHeaders(),
    }
  );
  return parseJson(res);
};

export const resendConnectOnboardingLink = async (accountId, sellerId) => {
  const res = await fetch(
    `${API_BASE_URL}/payapi/admin/connect/resend-onboarding-link`,
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ accountId, sellerId }),
    }
  );
  return parseJson(res);
};

export const openStripeUrl = (url) => {
  if (!url) {
    throw new Error("No Stripe URL returned");
  }
  window.open(url, "_blank", "noopener,noreferrer");
};
